import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { Button, Icon, Popup } from "semantic-ui-react";

interface ClickToCopyProps {
  text: string;
}

interface ClickToCopyState {
  open?: boolean;
}

export default class ClickToCopy extends React.Component<
  ClickToCopyProps,
  ClickToCopyState
> {
  constructor(props: ClickToCopyProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Popup
          open={this.state.open}
          content="Copied to clipboard!"
          on="click"
          position="top center"
          trigger={
            <CopyToClipboard text={this.props.text} onCopy={this.onCopy}>
              <Button icon basic compact>
                <Icon name="copy" />
              </Button>
            </CopyToClipboard>
          }
        ></Popup>
      </>
    );
  }

  onCopy = () => {
    this.setState({ open: true });
    setTimeout(() => {
      this.setState({ open: false });
    }, 2000);
  };
}
